import { AvatarWithPrettyNull } from "@/components/pieces/users/AvatarWithPrettyNull";
import { SUBTEXT_COLOR } from "@/css/constants";

interface AvatarWithVolumeProps {
  user: {
    name?: string;
    photo?: string;
  };
  size: number;
  volumeLevel: number;
}

export function AvatarWithVolume(props: AvatarWithVolumeProps) {
  const size = props.size;
  return (
    <div className="w-full grid place-items-center">
      <div
        style={{
          gridArea: "1/1",
          borderRadius: "100%",
          width: size,
          height: size,
          border: `2px solid ${SUBTEXT_COLOR}`,
          opacity: props.volumeLevel * 0.625,
          transition: "transform 0.1s ease-out, opacity 0.1s ease-out",
        }}
      />
      <div style={{ gridArea: "1/1" }}>
        <AvatarWithPrettyNull user={props.user} size={size} />
      </div>
    </div>
  );
}
